import { useState, useEffect, useCallback, useRef } from "react";

export function useApi(fn, { autoRefresh = 0, deps = [] } = {}) {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null,
    lastChecked: null,
  });
  const fnRef = useRef(fn);
  fnRef.current = fn;

  const load = useCallback(async (silent = false) => {
    if (!silent) setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const data = await fnRef.current();
      setState({ data, loading: false, error: null, lastChecked: new Date() });
    } catch (error) {
      setState({ data: null, loading: false, error, lastChecked: new Date() });
    }
  }, []);

  useEffect(() => {
    load();
    if (autoRefresh > 0) {
      const id = setInterval(() => load(true), autoRefresh);
      return () => clearInterval(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, autoRefresh, ...deps]);

  return { ...state, refetch: load };
}
